import React from "react";
import { UserToggler } from "../../components";

export function Topbar() {

  return (
    <div className="topbar">

      {/* <NotificationCenter /> */}

      <UserToggler />

    </div>
  );
}
